/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MembershipDefinitions {
    "use strict";

    export class MembershipDefinitionsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        private _isEmployee: boolean;
        public _isPasswordRequired: boolean;
        public _passwordEntry: string;
        private _filterService: angular.IFilterService;
        private rootScope: ng.IRootScopeService;
        private busyService: Meevo.Components.Busy.IBusyService

        constructor(appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            rootScope: ng.IRootScopeService,
            busyService: Meevo.Components.Busy.IBusyService) {

            super(appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService);

            this.rootScope = rootScope;
            this.busyService = busyService;
        }

        initializeContext(): void {
            // initialize end points
            this.baseEndpoint = this.appSettings.API_ENDPOINTS.employee;
            // initialize templatepaths
            this.sectionTemplatePath = "app/plugins/membershipDefinitions/sectionViews/";

            // TODO: Review per conversation if we should use the "main" tab key or overall module key as the base of the CRUD action keys
            this.buildCrudSecurityKeys(this.securityKeys.DATA_EMPLOYEE_TAB_MAIN);
        }

        initializeHeader(model: any): void {
            this.headerContent = model.isLocationEmployee ? model.lastName + ", " + model.firstName : model.userName;


            model.userLocations.forEach(userLoc => {
                if (userLoc.smartCenters === undefined)
                    userLoc.smartCenters = new Array<Model.DataDetail>();
                if (userLoc.securityRoles === undefined)
                    userLoc.securityRoles = new Array<Model.DataDetail>();
            });
            
        }

        initializeSections(): void {
            this.initializeContext();
            // Adding sections items that represent areas in the maintenance form
           if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new MainSection(0,
                    "SECTION_EMPLOYEE_MAIN",
                    "main.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeMain,
                    null,
                    this.securityKeys.DATA_EMPLOYEE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new CommissionSection(0,
                    "SECTION_MEMBERSHIP_DEF_COMMISSION",
                    "commission.template.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeMain,
                    null,
                    this.securityKeys.DATA_EMPLOYEE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));

          if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_EMPLOYEE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ))
                this.sections.push(new DocsSection(0,
                    "SECTION_MEMBERSHIP_DEF_DOCS",
                    "docs.template.html",
                    true,
                    false,
                    this.baseEndpoint,
                    "",
                    this.loggingService,
                    this.dataService,
                    this.identityService,
                    Meevo.Model.NounEnum.EmployeeMain,
                    null,
                    this.securityKeys.DATA_EMPLOYEE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ ));

            //if (this.securityChecker.hasSecurity(this.securityKeys.DATA_EMPLOYEE_TAB_SHARED + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) +
            //    this.sections.push(new SharedSection(2, "SECTION_EMPLOYEE_SHARED", "shared.html", true, false, '', '',
            //        this.loggingService, this.dataService,this.identityService));

        }

        commissionsOverride(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/membershipDefinitions/sectionViews/commission.modal.template.html",
                clickOutsideToClose: true,
                controller: "meevo.plugins.membershipDefinitions.MembershipDefinitionsController",
                controllerAs: "vm",
                locals: {
                    scope: null
                }
            }
            this.modalService.showCustom(options);
        }

        addDocument(): void {
            let options: Meevo.Components.Modal.IModalOptions = {
                templateUrl: "app/plugins/membershipDefinitions/sectionViews/docs.modal.template.html",
                clickOutsideToClose: true,
                controller: "meevo.plugins.membershipDefinitions.MembershipDefinitionsController",
                controllerAs: "vm",
                locals: {
                    scope: null
                }
            }
            this.modalService.showCustom(options);
        }


    }

}